export default "__VITE_ASSET__291138a2__"